import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { format } from 'date-fns';
import {
  Alert,
  Button,
  ButtonGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Modal,
  Row,
  Spinner,
  Toast,
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { fi } from 'date-fns/locale';
import { useNavigate, useParams } from 'react-router-dom';
import { Icon, Rating } from '@lomarengas/design-system';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LOADING_STATUS } from '../../common/constants';
import { initialTranslationsState } from '../../common/types/translations.types';
import {
  ActionButtons,
  Emoji,
  Loader,
  SectionHeader,
  VerticalTabPane,
  VerticalTabs,
} from '../../common/components';

import {
  getFeedbackDetailsAsync,
  FeedbackDetails,
  FeedbackAnswer,
  FeedbackQuestion,
  selectFeedbackDetails,
  selectFeedbackDetailsLoadingStatus,
  updateFeedbackAsync,
  sendFeedbackToOwner,
  changeStateAnswerApproved,
  changeStateAnswerRating,
  changeStateAnswerText,
  changeStateAnswerReply,
  changeStateAnswerSelection,
  changeStateFeedbackDateOfPublication,
  changeStateFeedbackServiceComment,
  changeStateFeedbackOwnerComment,
  sendFeedbackToCaretaker,
  sendFeedbackToCleaner,
  changeStateFeedbackState,
  OwnerCleanerCaretakerFeedbackEmailReplyDto,
  changeStateFeedbackSentToOwner,
  changeStateFeedbackSentToCleaner,
  changeStateFeedbackSentToMaintainer,
  updateFeedbackSentToOwnerAsync,
  updateFeedbackSentToMaintainerAsync,
  updateFeedbackSentToCleanerAsync,
  ExternalEmailFeedbackEmailReplyDto,
  changeStateFeedbackSentToExternalEmailAddress,
  updateFeedbackSentToExternalEmailAddressAsync,
  sendFeedbackToExternal,
  changeStateFeedbackOwnerEmailFreeText,
  changeStateFeedbackMaintainerEmailFreeText,
  changeStateFeedbackExternalEmailFreeText,
  changeStateFeedbackCleanerEmailFreeText,
  getFeedbackDetailsAsPdfAsync,
} from './FeedbacksSlice';
import DemoImage from '../../assets/img/demoimages/rovarakka01.jpeg';
import {
  dateToDateOnlyString,
  formatDateToFinnish,
  isValidDate,
  JsDateToString,
} from '../../common/utils/dateUtils';
import {
  fetchFeedbackDetailsAsPdf,
  updateFeedbackSentToOwner,
} from '../../common/api/feedBackService';

const FeedbackDetailsView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const backLinkUrl = 'feedbacks/search';
  const dispatch = useAppDispatch();
  const feedbackDetails = useAppSelector(selectFeedbackDetails);
  const feedbackDetailsLoadingStatus = useAppSelector(
    selectFeedbackDetailsLoadingStatus,
  );
  const initialFeedBackState: FeedbackDetails = {
    accommodationName: '',
    accommodationNumber: '',
    answerTime: undefined,
    answers: undefined,
    approvedRejectedTime: undefined,
    bookingEndTime: undefined,
    bookingNumber: '',
    bookingStartTime: undefined,
    contactRequested: false,
    contactEmail: undefined,
    contactExplanation: undefined,
    customerEmail: '',
    customerFirstName: '',
    customerLastName: '',
    customerNumber: '',
    feedbackState: '',
    locale: '',
    ownerFirstName: '',
    ownerLastName: '',
    ownerNumber: '',
    sentToOwner: undefined,
    sentToMaintainer: undefined,
    sentToCleaner: undefined,
    sentTime: undefined,
    siteId: '',
    id: '',
    accommodationImageUrl: '',
    serviceComment: '',
    ownerComment: '',
    dateOfPublication: null,
    caretakerEmails: [],
    cleanerEmails: [],
    isDeleted: false,
    state: 'InProgress',
    ownerEmails: [],
    feedbackHandlerFirstName: '',
    feedbackHandlerLastName: '',
    autoApprove: undefined,
    autoApproveReason: undefined,
    sendEmailToCleaner: undefined,
    sendEmailToCaretaker: undefined,
    hasCaretaker: undefined,
    hasCleaner: undefined,
  };

  interface ModalState {
    showEditModal: boolean;
    feedBackAnswer: FeedbackAnswer;
  }

  const initialModalState: ModalState = {
    showEditModal: false,
    feedBackAnswer: null,
  };
  const [feedback, setFeedback] = useState(initialFeedBackState);
  /*
  const [ownerFeedbackEmailReplyFreeText, setOwnerFeedbackEmailReplyFreeText] =
    useState<string>(null);
  const [
    maintainerFeedbackEmailReplyFreeText,
    setMaintainerFeedbackEmailReplyFreeText,
  ] = useState<string>(null);
  const [
    externalEmailAddressFeedbackEmailReplyFreeText,
    setExternalEmailAddressFeedbackEmailReplyFreeText,
  ] = useState<string>(null);
  const [
    cleanerFeedbackEmailReplyFreeText,
    setCleanerFeedbackEmailReplyFreeText,
  ] = useState<string>(null);
  */
  const [
    feedbackEmailExternalEmailAddress,
    setFeedbackEmailExternalEmailAddress,
  ] = useState<string>(null);
  const initFetch = useCallback(() => {
    dispatch(getFeedbackDetailsAsync(params.feedbackId));
  }, [dispatch, params.feedbackId]);
  const Tabs: string[] = [
    'Palaute kohteelle',
    'Palaute omistajalle',
    'Palautteen julkaisu',
    'Palautteen lähetys',
  ];
  const [activeTab, setActiveTab] = useState<string>(Tabs[0]);
  const [commentSubmitted, setCommentSubmitted] = useState(false);
  const updateActiveTab = (tab: string) => {
    setCommentSubmitted(false);
    setActiveTab(tab);
  };
  const formatDateWithClock = (date: Date) => {
    if (typeof date === 'string') {
      const convertedDate = new Date(date);
      return `${convertedDate.getDate()}.${
        convertedDate.getMonth() + 1
      }.${convertedDate.getFullYear()} klo ${convertedDate.getHours()}:${convertedDate.getMinutes()}`;
    }
    return `${date.getDate()}.${
      date.getMonth() + 1
    }.${date.getFullYear()} klo ${date.getHours()}:${date.getMinutes()}`;
  };
  // Demo states

  const [loadingPdf, setLoadingPdf] = useState(false);
  const starRatingApproved = true;
  const textFeedbackApproved = true;
  const isRecommended = true;
  const [feedbackPublishTime, setFeedbackPublishTime] = useState<string>(null);
  const [doFeedBackUpdate, setDoFeedBackUpdate] = useState<boolean>(false);
  const [feedbackPublishTimed, setFeedbackPublishTimed] =
    useState<boolean>(false);
  const [EditRatingModalState, setEditRatingModalState] =
    useState(initialModalState);
  const [EditTextModalState, setEditTextModalState] =
    useState(initialModalState);
  const [EditSelectionModalState, setEditSelectionModalState] =
    useState(initialModalState);
  const [ReplyTextModalState, setReplyTextModalState] =
    useState(initialModalState);
  const [ratingRangeValue, setRatingRangeValue] = useState<number>(2.5);
  const [textValue, setTextValue] = useState<string>('');
  const [selectionValue, setSelectionValue] = useState<number>(0);
  // const [serviceCommentText, setServiceCommentText] = useState<string>('');
  // const [dateOfPublication, setDateOfPublication] = useState<string>();
  // const [commentSubmitted, setCommentSubmitted] = useState(false);
  useEffect(() => {
    initFetch();
  }, [initFetch]);
  useEffect(() => {
    if (feedbackDetails && feedbackDetails.id) {
      setFeedback(feedbackDetails);
      if (feedbackDetails.dateOfPublication != null) {
        setFeedbackPublishTimed(true);
      } else {
        setFeedbackPublishTimed(false);
      }
      if (feedbackDetails.externalEmailAddress != null) {
        setFeedbackEmailExternalEmailAddress(
          feedbackDetails.externalEmailAddress,
        );
      }
    }
  }, [feedbackDetails?.id, feedbackDetails?.sentTime]);
  useEffect(() => {
    if (doFeedBackUpdate) {
      dispatch(updateFeedbackAsync(feedback));
      setDoFeedBackUpdate(false);
    }
  }, [doFeedBackUpdate, dispatch, feedback]);
  useEffect(() => {}, [selectionValue]);

  const handleFeedbackSave = (
    commentSave: boolean,
    overrideFeedback?: FeedbackDetails,
  ) => {
    const currentFeedBack = overrideFeedback ?? feedback;

    const serviceAnswers = currentFeedBack.answers.filter(
      a => a.question.serviceQuestion === true,
    );
    const totalQuestions = serviceAnswers.length;

    const approvedAnswerCount = serviceAnswers.filter(
      a => a.approved === true,
    ).length;
    const rejectedAnswerCount = serviceAnswers.filter(
      a => a.approved === false,
    ).length;
    const totalReviewed = approvedAnswerCount + rejectedAnswerCount;

    console.log(`ServiceAnswers: ${totalQuestions}`);
    console.log(`approvedAnswerCount: ${approvedAnswerCount}`);
    console.log(`rejectedAnswerCount: ${rejectedAnswerCount}`);
    console.log(`totalReviewed: ${totalReviewed}`);
    let newFeedBackState = currentFeedBack.feedbackState as
      | 'Approved'
      | 'PartiallyApproved'
      | 'Rejected'
      | 'InProgress';

    // 🧩 Rule 1: any unanswered → InProgress
    if (totalReviewed < totalQuestions) {
      newFeedBackState = 'InProgress';
    }
    // 🧩 Rule 2: all answered and all approved
    else if (approvedAnswerCount === totalQuestions) {
      newFeedBackState = 'Approved';
    }
    // 🧩 Rule 3: all answered and all rejected
    else if (rejectedAnswerCount === totalQuestions) {
      newFeedBackState = 'Rejected';
    }
    // 🧩 Rule 4: all answered but mixed approval
    else {
      newFeedBackState = 'PartiallyApproved';
    }

    if (newFeedBackState !== currentFeedBack.feedbackState) {
      dispatch(changeStateFeedbackState({ newFeedBackState }));
      setFeedback(prev => ({ ...prev, state: newFeedBackState }));
    }
    if (commentSave) setCommentSubmitted(true);
    setDoFeedBackUpdate(true);
  };

  const handleRatingSelectionChange = (selection: number) => {
    setSelectionValue(selection);
  };
  const handleRatingTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setTextValue(Event.target.value);
  };
  const handleServiceCommentTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const serviceComment = Event.target.value;
    setFeedback(prev => ({ ...prev, serviceComment }));
    dispatch(
      changeStateFeedbackServiceComment({
        serviceComment,
      }),
    );
  };
  const handleOwnerCommentTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const ownerComment = Event.target.value;
    setFeedback(prev => ({ ...prev, ownerComment }));
    dispatch(
      changeStateFeedbackOwnerComment({
        ownerComment,
      }),
    );
  };

  const handleOwnerEmailFreetextTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const ownerEmailFreeText = Event.target.value;
    setFeedback(prev => ({ ...prev, ownerEmailFreeText }));
    dispatch(
      changeStateFeedbackOwnerEmailFreeText({
        ownerEmailFreeText,
      }),
    );
  };

  const handleMaintainerEmailFreetextTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const maintainerEmailFreeText = Event.target.value;
    setFeedback(prev => ({ ...prev, maintainerEmailFreeText }));
    dispatch(
      changeStateFeedbackMaintainerEmailFreeText({
        maintainerEmailFreeText,
      }),
    );
  };

  const handleCleanerEmailFreetextTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const cleanerEmailFreeText = Event.target.value;
    setFeedback(prev => ({ ...prev, cleanerEmailFreeText }));
    dispatch(
      changeStateFeedbackCleanerEmailFreeText({
        cleanerEmailFreeText,
      }),
    );
  };

  const handleExternalEmailFreetextTextChange = (
    Event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const externalEmailFreeText = Event.target.value;
    setFeedback(prev => ({ ...prev, externalEmailFreeText }));
    dispatch(
      changeStateFeedbackExternalEmailFreeText({
        externalEmailFreeText,
      }),
    );
  };

  const handleRangeChange = (Event: React.ChangeEvent<HTMLInputElement>) => {
    setRatingRangeValue(Number(Event.target.value));
  };

  const handleDateOfPublicationChange = (selectedDate: Date) => {
    // Store as a serializable ISO string (not a Date object) so Redux state
    // stays serializable; the calendar/render parse it back via new Date().
    const dateOfPublicationValue = selectedDate.toISOString();
    setFeedback(prev => ({
      ...prev,
      dateOfPublication: dateOfPublicationValue,
    }));
    dispatch(
      changeStateFeedbackDateOfPublication({
        dateOfPublicationValue,
      }),
    );
    handleFeedbackSave(false);
    // setDateOfPublication(dateOfPublication.toString());
  };

  const changeDateOfPublicationToNull = () => {
    const nulli = null;
    setFeedback(prev => ({ ...prev, dateOfPublication: null }));
    dispatch(
      changeStateFeedbackDateOfPublication({
        nulli,
      }),
    );
    setFeedbackPublishTimed(false);
    handleFeedbackSave(false);
  };

  const updateAnswer = (
    answer: FeedbackAnswer,
    patch: Partial<FeedbackAnswer>,
  ) => {
    const updatedFeedback = {
      ...feedback,
      answers: feedback.answers.map(a =>
        a.id === answer.id ? { ...a, ...patch } : a,
      ),
    };
    setFeedback(updatedFeedback);
    handleFeedbackSave(false, updatedFeedback);
  };

  const changeAnswerText = (answer: FeedbackAnswer) => {
    dispatch(
      changeStateAnswerText({
        answer,
        textValue,
      }),
    );
    setEditTextModalState({
      showEditModal: false,
      feedBackAnswer: null,
    });
    updateAnswer(answer, {
      originalTextValue: answer.originalTextValue ?? answer.textValue,
      textValue,
    });
  };
  const changeAnswerRating = (answer: FeedbackAnswer) => {
    dispatch(
      changeStateAnswerRating({
        answer,
        ratingRangeValue,
      }),
    );
    setEditRatingModalState({
      showEditModal: false,
      feedBackAnswer: null,
    });
    updateAnswer(answer, {
      originalNumbericValue:
        answer.originalNumbericValue ?? answer.numbericValue,
      numbericValue: ratingRangeValue,
    });
  };
  const changeAnswerApproved = (answer: FeedbackAnswer, approved: boolean) => {
    dispatch(changeStateAnswerApproved({ answer, approved }));
    updateAnswer(answer, { approved });
  };
  const changeReplyText = (answer: FeedbackAnswer) => {
    dispatch(
      changeStateAnswerReply({
        answer,
        textValue,
      }),
    );
    setReplyTextModalState({
      showEditModal: false,
      feedBackAnswer: null,
    });
    updateAnswer(answer, { reply: textValue });
  };
  const changeAnswerSelection = (answer: FeedbackAnswer) => {
    dispatch(
      changeStateAnswerSelection({
        answer,
        selectionValue,
      }),
    );
    setEditSelectionModalState({
      showEditModal: false,
      feedBackAnswer: null,
    });
    updateAnswer(answer, {
      originalNumbericValue:
        answer.originalNumbericValue ?? answer.numbericValue,
      numbericValue: selectionValue,
    });
  };
  const openRatingModal = (feedbackAnswer: FeedbackAnswer) => {
    setEditRatingModalState({
      showEditModal: true,
      feedBackAnswer: feedbackAnswer,
    });
    setRatingRangeValue(feedbackAnswer.numbericValue);
  };
  /*
  const openTextModal = (feedbackAnswer: FeedbackAnswer) => {
    setEditTextModalState({
      showEditModal: true,
      feedBackAnswer: feedbackAnswer,
    });
    setTextValue(feedbackAnswer.textValue.toString());
  };

   */
  const openSelectionModal = (feedbackAnswer: FeedbackAnswer) => {
    setEditSelectionModalState({
      showEditModal: true,
      feedBackAnswer: feedbackAnswer,
    });
    setSelectionValue(feedbackAnswer.numbericValue);
  };
  const openReplyModal = (feedbackAnswer: FeedbackAnswer) => {
    setReplyTextModalState({
      showEditModal: true,
      feedBackAnswer: feedbackAnswer,
    });
    if (feedbackAnswer.reply != null) {
      setTextValue(feedbackAnswer.reply.toString());
    }
  };

  const saveAndSendFeedbackToOwner = () => {
    // Save feedback first, THEN send it to owner
    const payload: OwnerCleanerCaretakerFeedbackEmailReplyDto = {
      feedbackId: feedback.id,
      freeText: feedback.ownerEmailFreeText,
    };
    const newDate = new Date();

    dispatch(changeStateFeedbackSentToOwner());
    dispatch(updateFeedbackSentToOwnerAsync(feedback.id))
      .unwrap()
      .then(() => {
        dispatch(sendFeedbackToOwner(payload));
        setFeedback(prev => ({ ...prev, sentToOwner: newDate.toISOString() }));
      });
  };
  const saveAndSendFeedbackToCaretaker = () => {
    // Save feedback first, THEN send it to caretaker
    const payload: OwnerCleanerCaretakerFeedbackEmailReplyDto = {
      feedbackId: feedback.id,
      freeText: feedback.maintainerEmailFreeText,
    };
    const newDate = new Date();

    dispatch(changeStateFeedbackSentToMaintainer());
    dispatch(updateFeedbackSentToMaintainerAsync(feedback.id))
      .unwrap()
      .then(() => {
        dispatch(sendFeedbackToCaretaker(payload));
        setFeedback(prev => ({
          ...prev,
          sentToMaintainer: newDate.toISOString(),
        }));
      });
  };

  const saveAndSendFeedbackToCleaner = () => {
    // Save feedback first, THEN send it to cleaner
    const payload: OwnerCleanerCaretakerFeedbackEmailReplyDto = {
      feedbackId: feedback.id,
      freeText: feedback.cleanerEmailFreeText,
    };
    const newDate = new Date();

    dispatch(changeStateFeedbackSentToCleaner());
    dispatch(updateFeedbackSentToCleanerAsync(feedback.id))
      .unwrap()
      .then(() => {
        dispatch(sendFeedbackToCleaner(payload));
        setFeedback(prev => ({
          ...prev,
          sentToCleaner: newDate.toISOString(),
        }));
      });
  };

  const saveAndSendFeedbackToExternalEmail = () => {
    // Save feedback first, THEN send it to owner
    const payload: ExternalEmailFeedbackEmailReplyDto = {
      feedbackId: feedback.id,
      freeText: feedback.externalEmailFreeText,
      emailAddress: feedbackEmailExternalEmailAddress,
    };

    dispatch(
      changeStateFeedbackSentToExternalEmailAddress(
        feedbackEmailExternalEmailAddress,
      ),
    );
    const newDate = new Date();
    dispatch(updateFeedbackSentToExternalEmailAddressAsync(payload))
      .unwrap()
      .then(() => {
        dispatch(sendFeedbackToExternal(payload));
        setFeedback(prev => ({
          ...prev,
          sentToExternalEmailAddress: newDate.toISOString(),
        }));
      });
  };

  const renderAnswerInner = answer => {
    if (answer.question.type === 'RATING') {
      const starValueHalf =
        answer.numbericValue != null
          ? Math.round((answer.numbericValue / 2) * 10) / 10
          : 0;
      const originalStarValueHalf =
        answer.originalNumbericValue != null
          ? Math.round((answer.originalNumbericValue / 2) * 10) / 10
          : null;
      return (
        <div key={`${answer.id}${answer.question.questionId}`}>
          <h2 className="h5">{answer.question.text}</h2>
          <div className="small text-gray-600 mb-24">
            (Kysymyksen ID: {answer.question.questionId})
          </div>
          <div className="d-flex align-items-center mb-24">
            <div className="d-flex gap-8 align-items-center bg-white bg-opacity-75 py-8 ps-16 pe-24 rounded shadow-sm">
              <Rating Rating={starValueHalf} />
              <span className="fw-bold">{starValueHalf} / 5</span>
            </div>
          </div>
          {originalStarValueHalf != null && (
            <>
              Alkuperäinen arvo
              <div className="d-flex align-items-center mb-24">
                <div className="d-flex gap-8 align-items-center bg-white bg-opacity-75 py-8 ps-16 pe-24 rounded shadow-sm">
                  <Rating Rating={originalStarValueHalf} />
                  <span className="fw-bold">{originalStarValueHalf} / 5</span>
                </div>
              </div>
            </>
          )}
          {answer.reply != null && (
            <>
              Vastaus
              <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                {answer.reply}
              </div>
            </>
          )}
          <div className="row g-24 justify-content-between">
            <div className="col-12 col-lg-auto">
              {answer.question.approvable && (
                <ButtonGroup className="w-100">
                  <Button
                    onClick={() => changeAnswerApproved(answer, true)}
                    variant={
                      answer.approved !== null && answer.approved
                        ? 'blue'
                        : 'outline-blue'
                    }
                  >
                    Hyväksy
                  </Button>
                  <Button
                    onClick={() => changeAnswerApproved(answer, false)}
                    variant={
                      answer.approved !== null && !answer.approved
                        ? 'blue'
                        : 'outline-blue'
                    }
                  >
                    Hylkää
                  </Button>
                </ButtonGroup>
              )}
              {answer.stateModified != null && (
                <p className="body-small mt-16 mb-0">
                  Tallennettu{' '}
                  {JsDateToString(
                    answer.stateModified,
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
            </div>
            <div className="col-12 col-lg-auto">
              <div className="d-flex flex-column flex-lg-row gap-8">
                {answer.question.modifiable && (
                  <Button
                    variant="outline-blue"
                    className="text-nowrap"
                    onClick={() => openRatingModal(answer)}
                  >
                    <Icon Name="pen" CssClass="me-8" />
                    Muokkaa
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (answer.question.type === 'TEXT') {
      return (
        <div key={`${answer.id}${answer.question.questionId}`}>
          <h2 className="h5">{answer.question.text}</h2>
          <div className="small text-gray-600 mb-24">
            (Kysymyksen ID: {answer.question.questionId})
          </div>
          <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
            {answer.textValue}
          </div>
          {answer.originalTextValue && (
            <>
              Alkuperäinen arvo
              <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                {answer.originalTextValue}
              </div>
            </>
          )}
          {answer.reply != null && (
            <>
              Vastaus
              <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                {answer.reply}
              </div>
            </>
          )}
          <div className="row g-24 justify-content-between">
            <div className="col-12 col-lg-auto">
              {answer.question.approvable && (
                <ButtonGroup className="w-100">
                  <Button
                    onClick={() => changeAnswerApproved(answer, true)}
                    variant={
                      answer.approved !== null && answer.approved
                        ? 'blue'
                        : 'outline-blue'
                    }
                  >
                    Hyväksy
                  </Button>
                  <Button
                    onClick={() => changeAnswerApproved(answer, false)}
                    variant={
                      answer.approved !== null && !answer.approved
                        ? 'blue'
                        : 'outline-blue'
                    }
                  >
                    Hylkää
                  </Button>
                </ButtonGroup>
              )}
              {answer.stateModified != null && (
                <p className="body-small mt-16 mb-0">
                  Tallennettu{' '}
                  {JsDateToString(
                    answer.stateModified,
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
            </div>
            <div className="col-12 col-lg-auto">
              <div className="d-flex flex-column flex-lg-row gap-8">
                {answer.question.modifiable && (
                  <Button
                    variant="outline-blue"
                    className="text-nowrap"
                    onClick={() =>
                      setEditTextModalState({
                        showEditModal: true,
                        feedBackAnswer: answer,
                      })
                    }
                  >
                    <Icon Name="pen" CssClass="me-8" />
                    Muokkaa
                  </Button>
                )}
                {answer.question.answerPossible && (
                  <Button
                    variant="outline-blue"
                    className="text-nowrap"
                    onClick={() => openReplyModal(answer)}
                  >
                    <Icon Name="reply" CssClass="me-8" />
                    Vastaa
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (answer.question.type === 'SELECTION') {
      return (
        <div key={`${answer.id}${answer.question.questionId}`}>
          <h2 className="h5">{answer.question.text}</h2>
          <div className="small text-gray-600 mb-32">
            (Kysymyksen ID: {answer.question.questionId})
          </div>
          <div className="d-flex align-items-center mb-24">
            <div className="d-flex gap-8 align-items-center bg-white bg-opacity-75 py-8 ps-16 pe-24 rounded shadow-sm">
              <Icon
                Name={
                  answer.numbericValue != null && answer.numbericValue
                    ? 'hand-thumbs-up'
                    : 'hand-thumbs-down'
                }
                CssClass="fs-4 text-primary"
              />
              <span className="fw-bold fs-5">
                {answer.numbericValue != null && answer.numbericValue ? (
                  <>Kyllä</>
                ) : (
                  <>Ei</>
                )}
              </span>
            </div>
          </div>
          {answer.originalNumbericValue != null && (
            <>
              Alkuperäinen arvo
              <div className="d-flex align-items-center mb-24">
                <div className="d-flex gap-8 align-items-center bg-white bg-opacity-75 py-8 ps-16 pe-24 rounded shadow-sm">
                  <Icon
                    Name={
                      answer.originalNumbericValue != null &&
                      answer.originalNumbericValue
                        ? 'hand-thumbs-up'
                        : 'hand-thumbs-down'
                    }
                    CssClass="fs-4 text-primary"
                  />
                  <span className="fw-bold fs-5">
                    {answer.originalNumbericValue != null &&
                    answer.originalNumbericValue ? (
                      <>Kyllä</>
                    ) : (
                      <>Ei</>
                    )}
                  </span>
                </div>
              </div>
            </>
          )}
          {answer.reply != null && (
            <>
              Vastaus
              <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                {answer.reply}
              </div>
            </>
          )}
          <div className="row g-24 justify-content-between">
            <div className="col-12 col-lg-auto">
              {answer.question.approvable && (
                <ButtonGroup className="w-100">
                  <Button
                    onClick={() => changeAnswerApproved(answer, true)}
                    variant={
                      answer.approved !== null && answer.approved
                        ? 'blue'
                        : 'outline-blue'
                    }
                  >
                    Hyväksy
                  </Button>
                  <Button
                    onClick={() => changeAnswerApproved(answer, false)}
                    variant={
                      answer.approved !== null && !answer.approved
                        ? 'blue'
                        : 'outline-blue'
                    }
                  >
                    Hylkää
                  </Button>
                </ButtonGroup>
              )}
              {answer.stateModified != null && (
                <p className="body-small mt-16 mb-0">
                  Tallennettu{' '}
                  {JsDateToString(
                    answer.stateModified,
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
            </div>
            <div className="col-12 col-lg-auto">
              <div className="d-flex flex-column flex-lg-row gap-8">
                {answer.question.modifiable && (
                  <Button
                    variant="outline-blue"
                    className="text-nowrap"
                    onClick={() => openSelectionModal(answer)}
                  >
                    <Icon Name="pen" CssClass="me-8" />
                    Muokkaa
                  </Button>
                )}
                {answer.question.answerPossible && (
                  <Button
                    variant="outline-blue"
                    className="text-nowrap"
                    onClick={() => openReplyModal(answer)}
                  >
                    <Icon Name="reply" CssClass="me-8" />
                    Vastaa
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (answer.question.type === 'SCORE') {
      return (
        <div key={`${answer.id}${answer.question.questionId}`}>
          <h2 className="h5">{answer.question.text}</h2>
          <div className="small text-gray-600 mb-32">
            (Kysymyksen ID: {answer.question.questionId})
          </div>
          <div className="row g-24 justify-content-between">
            <div className="col-12 col-lg-auto">
              <div className="d-flex align-items-center">
                <span className="fs-4 d-inline-block py-4 px-3 bg-white bg-opacity-75 shadow-sm rounded">
                  {answer.numbericValue}
                </span>
                <Emoji
                  CssClass="ms-16"
                  Score={answer.numbericValue}
                  Size={28}
                />
              </div>
            </div>
            {answer.reply != null && (
              <div>
                Vastaus
                <div className="p-24 bg-white bg-opacity-75 rounded shadow-sm mb-24">
                  {answer.reply}
                </div>
              </div>
            )}
            <div className="col-12 col-lg-auto">
              <div className="d-flex flex-column flex-lg-row gap-8">
                {answer.question.answerPossible && (
                  <Button
                    variant="outline-blue"
                    onClick={() => openReplyModal(answer)}
                  >
                    <Icon Name="reply" CssClass="me-8" />
                    Vastaa
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };
  const renderAnswer = answer => {
    return (
      <>
        <hr className="hr-light my-32" />
        {renderAnswerInner(answer)}
      </>
    );
  };
  const printFeedBackAsPdf = async () => {
    setLoadingPdf(true);
    try {
      const pdfBytes = await fetchFeedbackDetailsAsPdf(feedback.id);

      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `Feedback_${feedback.id}.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Failed to download PDF', err);
    } finally {
      setLoadingPdf(false);
    }
  };

  if (feedbackDetails.id === '') {
    return <div />;
  }

  return (
    <>
      <Helmet>
        <title>Palautteet - Palautteen tiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={() => navigate(-1)}
          Breadcrumbs={['Palautteet']}
          Title={`Palaute kohteelle ${feedbackDetails.accommodationNumber} ${feedbackDetails.accommodationName}`}
        />
        <Loader
          IsLoading={feedbackDetailsLoadingStatus === LOADING_STATUS.LOADING}
        />
        {feedbackDetailsLoadingStatus === LOADING_STATUS.IDLE && (
          <VerticalTabs
            ActiveTab={activeTab}
            ChangeTab={updateActiveTab}
            TabContainerId="feedbackTabs"
            Tabs={Tabs}
          >
            <VerticalTabPane IsActive={activeTab === Tabs[0]} Name={Tabs[0]}>
              <Row>
                {feedback.accommodationImageUrl != null && (
                  <Col className="order-lg-2 mb-32" xs={12} lg={3} xxl={4}>
                    <img
                      className="w-100"
                      src={feedback.accommodationImageUrl}
                      alt=""
                    />
                  </Col>
                )}
                {feedback.accommodationImageUrl == null && (
                  <Col className="order-lg-2 mb-32" xs={12} lg={3} xxl={4}>
                    <img className="w-100" src={DemoImage} alt="" />
                  </Col>
                )}
                <Col className="mb-32" xs={12} lg={9} xxl={8}>
                  <h2 className="h5">Asiakas</h2>
                  <p className="mb-32">
                    {feedback.customerNumber} {feedback.customerFirstName}{' '}
                    {feedback.customerLastName}
                    <br />
                    {feedback.customerEmail}
                  </p>
                  {feedback.contactRequested && (
                    <h2 className="h5">Yhteydenottopyyntö</h2>
                  )}
                  {feedback.contactRequested && feedback.contactEmail && (
                    <p className="mb-32">
                      Sähköposti: {feedback.contactEmail}
                      <br />
                      {feedback.contactExplanation &&
                        `Syy: ${feedback.contactExplanation}`}
                    </p>
                  )}
                  <h2 className="h5">Omistaja</h2>
                  <p className="mb-32">
                    {feedback.ownerNumber} {feedback.ownerFirstName}{' '}
                    {feedback.ownerLastName}
                    {feedback.ownerEmails?.length > 0 && (
                      <>
                        <br />
                        Sähköposti:{' '}
                        {[
                          ...new Set(
                            feedback.ownerEmails.map(e =>
                              e.emailAddress.trim().toLowerCase(),
                            ),
                          ),
                        ].join('; ')}
                      </>
                    )}
                  </p>
                  <h2 className="h5">Varaus</h2>
                  <p className="mb-8">
                    Varausnumero: {feedback.bookingNumber} <br />
                    Aika: {feedback.bookingStartTime}
                    {' - '}
                    {feedback.bookingEndTime}
                  </p>
                  <p className="mb-8">
                    {!loadingPdf && (
                      <Button
                        variant="primary"
                        onClick={() => printFeedBackAsPdf()}
                        disabled={loadingPdf}
                      >
                        Tulosta palaute PDF muodossa
                      </Button>
                    )}
                    {loadingPdf && (
                      <>
                        <Spinner
                          animation="border"
                          variant="primary"
                          role="status"
                        />
                        <span className="">Ladataan PDF...</span>
                      </>
                    )}
                    <p>
                      <br />
                      {feedbackDetails.feedbackHandlerFirstName &&
                        feedbackDetails.feedbackHandlerLastName && (
                          <p className="mb-8">
                            Käsittelijä:{' '}
                            {feedbackDetails.feedbackHandlerFirstName}{' '}
                            {feedbackDetails.feedbackHandlerLastName}
                          </p>
                        )}
                      {feedbackDetails.autoApprove !== undefined &&
                        feedbackDetails.autoApprove !== null && (
                          <p className="mb-8">
                            <strong>N8n Päätös:</strong>{' '}
                            <span
                              className={
                                feedbackDetails.autoApprove
                                  ? 'text-success'
                                  : 'text-danger'
                              }
                            >
                              {feedbackDetails.autoApprove ? 'Kyllä' : 'Ei'}
                            </span>
                            {feedbackDetails.autoApproveReason && (
                              <>
                                <br />
                                <strong>Syy:</strong>{' '}
                                {feedbackDetails.autoApproveReason}
                              </>
                            )}
                          </p>
                        )}
                      {feedbackDetails.sendEmailToCleaner !== undefined &&
                        feedbackDetails.sendEmailToCleaner !== null && (
                          <p className="mb-8">
                            <strong>Lähetä palaute siivoojalle:</strong>{' '}
                            <span
                              className={
                                feedbackDetails.sendEmailToCleaner
                                  ? 'text-success'
                                  : 'text-danger'
                              }
                            >
                              {feedbackDetails.sendEmailToCleaner
                                ? 'Kyllä'
                                : 'Ei'}
                            </span>
                          </p>
                        )}
                      {feedbackDetails.sendEmailToCaretaker !== undefined &&
                        feedbackDetails.sendEmailToCaretaker !== null && (
                          <p className="mb-8">
                            <strong>Lähetä palaute huoltajalle:</strong>{' '}
                            <span
                              className={
                                feedbackDetails.sendEmailToCaretaker
                                  ? 'text-success'
                                  : 'text-danger'
                              }
                            >
                              {feedbackDetails.sendEmailToCaretaker
                                ? 'Kyllä'
                                : 'Ei'}
                            </span>
                          </p>
                        )}
                    </p>
                  </p>
                </Col>
              </Row>

              {feedback.answers !== undefined &&
                feedback.answers
                  .filter(answer => answer.question.questionId === 3346)
                  .map(answer => (
                    <React.Fragment key={`${answer.question.id}-${answer.id}`}>
                      {renderAnswer(answer)}
                    </React.Fragment>
                  ))}
              {feedback.answers !== undefined &&
                feedback.answers
                  .filter(answer => answer.question.questionId === 3343)
                  .map(answer => (
                    <React.Fragment key={`${answer.question.id}-${answer.id}`}>
                      {renderAnswer(answer)}
                    </React.Fragment>
                  ))}
              {feedback.answers !== undefined &&
                feedback.answers
                  .filter(answer => answer.question.questionId === 3344)
                  .map(answer => (
                    <React.Fragment key={`${answer.question.id}-${answer.id}`}>
                      {renderAnswer(answer)}
                    </React.Fragment>
                  ))}
              {feedback.answers !== undefined &&
                feedback.answers
                  .filter(
                    answer =>
                      answer.question.serviceQuestion === true &&
                      answer.question.questionId !== 3346 &&
                      answer.question.questionId !== 3343 &&
                      answer.question.questionId !== 3344,
                  )
                  .map(answer => (
                    <React.Fragment key={`${answer.question.id}-${answer.id}`}>
                      {renderAnswer(answer)}
                    </React.Fragment>
                  ))}
              <hr className="hr-light my-32" />

              <Form.Group controlId="feedbackProviderCommentInput">
                <Form.Label>Lomarenkaan kommentit</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="feedbackProviderCommentInput"
                  value={feedback?.serviceComment ?? ''}
                  onChange={e => handleServiceCommentTextChange(e)}
                />
                <ButtonGroup className="mt-24">
                  <Button
                    variant="primary"
                    onClick={() => handleFeedbackSave(true)}
                  >
                    Tallenna kommentit
                  </Button>
                  {commentSubmitted && (
                    <Alert variant="success">
                      Lomarenkaan kommentit tallennettu!
                    </Alert>
                  )}
                </ButtonGroup>
              </Form.Group>
            </VerticalTabPane>

            <VerticalTabPane IsActive={activeTab === Tabs[1]} Name={Tabs[1]}>
              <p className="mb-24">
                Alla olevia arvioita ei julkaista netissä. Ne on tarkoitettu
                kohteen omistajalle tiedoksi ja toimenpiteitä varten.
              </p>

              <h3 className="h5 mb-16">Asteikko 0 - 4</h3>
              <div className="d-grid gap-2">
                <span className="d-flex gap-3 align-items-center body-small">
                  <span style={{ width: '40px' }}>0 / 4</span>
                  <Emoji Score={0} /> En osaa sanoa / ei ollut
                </span>

                <span className="d-flex gap-3 align-items-center body-small">
                  <span style={{ width: '38px' }}>1 / 4</span>{' '}
                  <Emoji Score={1} /> Paljon parantamisen varaa
                </span>

                <span className="d-flex gap-3 align-items-center body-small">
                  <span style={{ width: '38px' }}>2 / 4</span>{' '}
                  <Emoji Score={2} /> Vähän parantamisen varaa
                </span>

                <span className="d-flex gap-3 align-items-center body-small">
                  <span style={{ width: '38px' }}>3 / 4</span>{' '}
                  <Emoji Score={3} /> Asiat ovat melko hyvin
                </span>

                <span className="d-flex gap-3 align-items-center body-small">
                  <span style={{ width: '38px' }}>4 / 4</span>{' '}
                  <Emoji Score={4} /> Asiakas kiittää
                </span>
              </div>

              {feedback.answers !== undefined &&
                feedback.answers
                  .filter(
                    answer =>
                      answer.question.ownerQuestion === true &&
                      answer.question.questionId !== 3356,
                  )
                  .map(answer => (
                    <React.Fragment key={`${answer.question.id}-${answer.id}`}>
                      {renderAnswer(answer)}
                    </React.Fragment>
                  ))}
              {feedback.answers !== undefined &&
                feedback.answers
                  .filter(
                    answer =>
                      answer.question.ownerQuestion === true &&
                      answer.question.questionId === 3356,
                  )
                  .map(answer => (
                    <React.Fragment key={`${answer.question.id}-${answer.id}`}>
                      {renderAnswer(answer)}
                    </React.Fragment>
                  ))}
              <hr className="hr-light my-32" />

              <Form.Group controlId="feedbackProviderCommentInput">
                <Form.Label>Omistajan kommentit</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="feedbackProviderCommentInput"
                  value={feedback?.ownerComment ?? ''}
                  onChange={e => handleOwnerCommentTextChange(e)}
                />
                <ButtonGroup className="mt-24">
                  <Button
                    variant="primary"
                    onClick={() => handleFeedbackSave(true)}
                  >
                    Tallenna kommentit
                  </Button>
                  {commentSubmitted && (
                    <Alert variant="success">
                      Omistaja kommentit tallennettu!
                    </Alert>
                  )}
                </ButtonGroup>
              </Form.Group>
            </VerticalTabPane>

            <VerticalTabPane IsActive={activeTab === Tabs[2]} Name={Tabs[2]}>
              <Form.Group controlId="feedbackPublishNowRadio" className="mb-32">
                <Form.Check
                  label="Julkaistaan heti"
                  type="radio"
                  name="feedbackPublishTime"
                  checked={!feedbackPublishTimed}
                  onChange={() => changeDateOfPublicationToNull()}
                />
                <Form.Text className="ms-40 text-gray-600">
                  Palaute julkaistaan heti ja on näkyvissä julkisesti
                  verkkokaupassa.
                </Form.Text>
              </Form.Group>
              <Form.Group
                controlId="feedbackPublishTimedRadio"
                className="mb-24"
              >
                <Form.Check
                  label="Ajastettu julkaisu"
                  type="radio"
                  checked={feedbackPublishTimed}
                  name="feedbackPublishTime"
                  onChange={() => setFeedbackPublishTimed(true)}
                />
                <Form.Text className="ms-40 text-gray-600">
                  Palaute julkaistaan ajastetusti ja alkaa näkymään
                  verkkokaupassa vasta valittuna ajankohtana.
                </Form.Text>
                {feedbackPublishTimed && (
                  <div className="ps-40 mt-16 col-lg-4">
                    <Form.Label>Valitse ajankohta</Form.Label>
                    <div className="w-100 position-relative">
                      <DatePicker
                        locale={fi}
                        selected={
                          isValidDate(feedback.dateOfPublication)
                            ? new Date(feedback.dateOfPublication)
                            : null
                        }
                        onChange={date => handleDateOfPublicationChange(date)}
                        selectsStart
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                      />
                      <Button
                        variant="link"
                        className="pe-none position-absolute end-0 top-0"
                        id="button-addon2"
                      >
                        <span className="bi bi-calendar2-event" />
                      </Button>
                    </div>
                  </div>
                )}
              </Form.Group>
            </VerticalTabPane>

            <VerticalTabPane IsActive={activeTab === Tabs[3]} Name={Tabs[3]}>
              <h3 className="h5 mb-16">Palautteen lähetys omistajalle</h3>
              {(feedback.ownerEmails === null ||
                feedback.ownerEmails?.length === 0) && (
                <p className="fw-bold text-danger">
                  Huom!. Omistajalla ei ole sähköpostiosoitetta. Palautetta ei
                  voi lähettää.
                </p>
              )}
              <p>
                {feedback.ownerEmails?.length > 0 && (
                  <>
                    Sähköposti:{' '}
                    {[
                      ...new Set(
                        feedback.ownerEmails.map(e =>
                          e.emailAddress.trim().toLowerCase(),
                        ),
                      ),
                    ].join('; ')}
                  </>
                )}
              </p>
              {feedback.sentToOwner != null && (
                <p className="body-small text-success fw-bold">
                  Lähetetty omistajalle:{' '}
                  {JsDateToString(
                    new Date(feedback.sentToOwner),
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
              <Form.Group className="mb-24">
                <Form.Label>Saateteksti</Form.Label>
                <Form.Control
                  as="textarea"
                  id="ownerEmailFreeText"
                  value={feedback?.ownerEmailFreeText}
                  onChange={e => handleOwnerEmailFreetextTextChange(e)}
                />
              </Form.Group>
              <Button
                variant="primary"
                disabled={
                  feedback.ownerEmails === null ||
                  feedback.ownerEmails.length === 0
                }
                onClick={() => saveAndSendFeedbackToOwner()}
              >
                <Icon Name="envelope-fill" CssClass="me-8" />
                Lähetä palaute omistajalle
                {feedback.sentToOwner != null && ' uudelleen'}
              </Button>

              <hr className="hr-light my-32" />

              <h3 className="h5 mb-16">Palautteen lähetys huoltajalle</h3>
              {!feedback.hasCaretaker ? (
                <p className="fw-bold text-secondary">
                  Kohteelle ei ole määritetty huoltajaa.
                </p>
              ) : (
                (!feedback.caretakerEmails ||
                  feedback.caretakerEmails.length === 0) && (
                  <p className="fw-bold text-danger">
                    Huom!. Huoltajalla ei ole sähköpostiosoitetta. Palautetta ei
                    voi lähettää.
                  </p>
                )
              )}
              {feedback.caretakerEmails?.length > 0 && (
                <>
                  Sähköposti:{' '}
                  {[
                    ...new Set(
                      feedback.caretakerEmails.map(e =>
                        e.emailAddress.trim().toLowerCase(),
                      ),
                    ),
                  ].join('; ')}
                </>
              )}
              {feedback.sentToMaintainer != null && (
                <p className="body-small text-success fw-bold">
                  Lähetetty huoltajalle:{' '}
                  {JsDateToString(
                    new Date(feedback.sentToMaintainer),
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
              <Form.Group className="mb-24">
                <Form.Label>Saateteksi</Form.Label>
                <Form.Control
                  as="textarea"
                  id="maintainerEmailFreeText"
                  value={feedback?.maintainerEmailFreeText}
                  onChange={e => handleMaintainerEmailFreetextTextChange(e)}
                />
              </Form.Group>
              <p className="body-small text-success fw-bold" />
              <Button
                variant="primary"
                disabled={
                  feedback.caretakerEmails === null ||
                  feedback.caretakerEmails?.length === 0
                }
                onClick={() => saveAndSendFeedbackToCaretaker()}
              >
                <Icon Name="envelope-fill" CssClass="me-8" />
                Lähetä palaute huoltajalle
                {feedback.sentToMaintainer != null && ' uudelleen'}
              </Button>

              <hr className="hr-light my-32" />

              <h3 className="h5 mb-16">Palautteen lähetys siivoojalle</h3>
              {!feedback.hasCleaner ? (
                <p className="fw-bold text-secondary">
                  Kohteelle ei ole määritetty siivoojaa.
                </p>
              ) : (
                (!feedback.cleanerEmails ||
                  feedback.cleanerEmails.length === 0) && (
                  <p className="fw-bold text-danger">
                    Huom!. Siivoojalla ei ole sähköpostiosoitetta. Palautetta ei
                    voi lähettää.
                  </p>
                )
              )}
              {feedback.sentToCleaner != null && (
                <p className="body-small text-success fw-bold">
                  Lähetetty siivoojalle:{' '}
                  {JsDateToString(
                    new Date(feedback.sentToCleaner),
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
              {feedback.cleanerEmails?.length > 0 && (
                <>
                  Sähköposti:{' '}
                  {[
                    ...new Set(
                      feedback.cleanerEmails.map(e =>
                        e.emailAddress.trim().toLowerCase(),
                      ),
                    ),
                  ].join('; ')}
                </>
              )}
              <Form.Group className="mb-24">
                <Form.Label>Saateteksti</Form.Label>
                <Form.Control
                  as="textarea"
                  id="cleanerEmailFreeText"
                  value={feedback?.cleanerEmailFreeText}
                  onChange={e => handleCleanerEmailFreetextTextChange(e)}
                />
              </Form.Group>
              <p className="body-small text-success fw-bold" />
              <Button
                variant="primary"
                disabled={
                  feedback.cleanerEmails === null ||
                  feedback.cleanerEmails?.length === 0
                }
                onClick={() => saveAndSendFeedbackToCleaner()}
              >
                <Icon Name="envelope-fill" CssClass="me-8" />
                Lähetä palaute siivoojalle
                {feedback.sentToCleaner != null && ' uudelleen'}
              </Button>

              <hr className="hr-light my-32" />

              <h3 className="h5 mb-16">
                Palautteen lähetys sähköpostiosoitteeseen
              </h3>

              <p>
                Sähköposti:{' '}
                <Form.Control
                  type="text"
                  defaultValue={feedback.externalEmailAddress}
                  onChange={e =>
                    setFeedbackEmailExternalEmailAddress(e.target.value)
                  }
                />
              </p>

              {feedback.sentToExternalEmailAddress != null && (
                <p className="body-small text-success fw-bold">
                  Lähetetty osoitteeseen: {feedback.externalEmailAddress}{' '}
                  {JsDateToString(
                    new Date(feedback.sentToExternalEmailAddress),
                    true,
                    true,
                    true,
                    ' ',
                    true,
                    true,
                  )}
                </p>
              )}
              <Form.Group className="mb-24">
                <Form.Label>Saateteksi</Form.Label>
                <Form.Control
                  as="textarea"
                  id="externalEmailFreeText"
                  value={feedback?.externalEmailFreeText}
                  onChange={e => handleExternalEmailFreetextTextChange(e)}
                />
              </Form.Group>
              <p className="body-small text-success fw-bold" />
              <Button
                variant="primary"
                disabled={feedbackEmailExternalEmailAddress === null}
                onClick={() => saveAndSendFeedbackToExternalEmail()}
              >
                <Icon Name="envelope-fill" CssClass="me-8" />
                Lähetä palaute sähköpostiin
                {feedback.sentToExternalEmailAddress != null && ' uudelleen'}
              </Button>
            </VerticalTabPane>
          </VerticalTabs>
        )}
      </Container>
      {feedbackDetailsLoadingStatus === LOADING_STATUS.IDLE && (
        <Modal
          show={EditRatingModalState.showEditModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Muokkaa palautetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup controlId="editModalDemo1">
              <div className="d-flex align-items-start mb-24">
                <h2 className="h5 me-8 mb-0 flex-grow-1">
                  {EditRatingModalState.feedBackAnswer != null &&
                    EditRatingModalState.feedBackAnswer.question.text}
                  <br />
                  <small className="text-gray-600">
                    (Kysymyksen ID:{' '}
                    {EditRatingModalState.feedBackAnswer != null &&
                      EditRatingModalState.feedBackAnswer.question.questionId}
                  </small>
                </h2>
              </div>
              <div className="d-flex align-items-center mb-24 mx-auto">
                <div className="d-flex gap-8 align-items-center bg-white bg-opacity-75 py-8 ps-16 pe-24 rounded shadow-sm">
                  <Rating Rating={ratingRangeValue * 0.5} />
                  <span className="fw-bold">{ratingRangeValue * 0.5} / 5</span>
                </div>
              </div>
              <div className="d-flex gap-3">
                <span>0</span>
                <Form.Range
                  defaultValue={
                    EditRatingModalState.feedBackAnswer != null &&
                    EditRatingModalState.feedBackAnswer.numbericValue
                  }
                  min={0}
                  max={10}
                  step={1}
                  onChange={e => handleRangeChange(e)}
                />
                <span>5</span>
              </div>
            </FormGroup>
            <hr className="hr-light my-32" />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="link"
              onClick={() =>
                setEditRatingModalState({
                  showEditModal: false,
                  feedBackAnswer: null,
                })
              }
            >
              Peruuta ja sulje
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                changeAnswerRating(EditRatingModalState.feedBackAnswer)
              }
            >
              Tallenna
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {feedbackDetailsLoadingStatus === LOADING_STATUS.IDLE && (
        <Modal
          show={EditTextModalState.showEditModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Muokkaa palautetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup controlId="editModalDemo1">
              <div className="d-flex align-items-start mb-24">
                <h2 className="h5 me-8 mb-0 flex-grow-1">
                  {EditTextModalState.feedBackAnswer != null &&
                    EditTextModalState.feedBackAnswer.question.text}
                  <br />
                  <small className="text-gray-600">
                    (Kysymyksen ID:{' '}
                    {EditTextModalState.feedBackAnswer != null &&
                      EditTextModalState.feedBackAnswer.question.questionId}
                  </small>
                </h2>
              </div>
            </FormGroup>

            <hr className="hr-light my-32" />

            <Form.Group controlId="editModalDemo2">
              <Form.Control
                as="textarea"
                rows={6}
                name="editModalDemo2"
                defaultValue={
                  EditTextModalState.feedBackAnswer != null &&
                  EditTextModalState.feedBackAnswer.textValue != null &&
                  EditTextModalState.feedBackAnswer.textValue
                }
                onChange={e => handleRatingTextChange(e)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="link"
              onClick={() =>
                setEditTextModalState({
                  showEditModal: false,
                  feedBackAnswer: null,
                })
              }
            >
              Peruuta ja sulje
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                changeAnswerText(EditTextModalState.feedBackAnswer)
              }
            >
              Tallenna
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {feedbackDetailsLoadingStatus === LOADING_STATUS.IDLE && (
        <Modal
          show={EditSelectionModalState.showEditModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Muokkaa palautetta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup controlId="editModalDemo1">
              <div className="d-flex align-items-start mb-24">
                <h2 className="h5 me-8 mb-0 flex-grow-1">
                  {EditSelectionModalState.feedBackAnswer != null &&
                    EditSelectionModalState.feedBackAnswer.question.text}
                  <br />
                  <small className="text-gray-600">
                    (Kysymyksen ID:{' '}
                    {EditSelectionModalState.feedBackAnswer != null &&
                      EditSelectionModalState.feedBackAnswer.question
                        .questionId}
                  </small>
                </h2>
              </div>
            </FormGroup>

            <hr className="hr-light my-32" />

            <Form.Group controlId="editModalDemo2">
              <ButtonGroup>
                <Button
                  onClick={() => handleRatingSelectionChange(1)}
                  variant={
                    selectionValue != null && selectionValue === 1
                      ? 'success'
                      : 'outline-success'
                  }
                >
                  Kyllä
                </Button>
                <Button
                  onClick={() => handleRatingSelectionChange(0)}
                  variant={
                    selectionValue != null && selectionValue === 0
                      ? 'secondary'
                      : 'outline-secondary'
                  }
                >
                  Ei
                </Button>
              </ButtonGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="link"
              onClick={() =>
                setEditSelectionModalState({
                  showEditModal: false,
                  feedBackAnswer: null,
                })
              }
            >
              Peruuta ja sulje
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                changeAnswerSelection(EditSelectionModalState.feedBackAnswer)
              }
            >
              Tallenna
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {feedbackDetailsLoadingStatus === LOADING_STATUS.IDLE && (
        <Modal
          show={ReplyTextModalState.showEditModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title>Vastaa palautteeseen</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup controlId="editModalDemo1">
              <div className="d-flex align-items-start mb-24">
                <h2 className="h5 me-8 mb-0 flex-grow-1">
                  {ReplyTextModalState.feedBackAnswer != null &&
                    ReplyTextModalState.feedBackAnswer.question.text}
                  <br />
                  <small className="text-gray-600">
                    (Kysymyksen ID:{' '}
                    {ReplyTextModalState.feedBackAnswer != null &&
                      ReplyTextModalState.feedBackAnswer.question.questionId}
                  </small>
                </h2>
              </div>
              <div className="d-flex align-items-start mb-24">
                <h2 className="h5 me-8 mb-0 flex-grow-1">
                  <p className="text-600">
                    {ReplyTextModalState.feedBackAnswer != null &&
                      ReplyTextModalState.feedBackAnswer.textValue}
                  </p>
                </h2>
              </div>
            </FormGroup>

            <hr className="hr-light my-32" />

            <Form.Group controlId="editModalDemo2">
              <Form.Control
                as="textarea"
                rows={6}
                name="editModalDemo2"
                defaultValue={
                  ReplyTextModalState.feedBackAnswer != null &&
                  ReplyTextModalState.feedBackAnswer.reply
                }
                onChange={e => handleRatingTextChange(e)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="link"
              onClick={() =>
                setReplyTextModalState({
                  showEditModal: false,
                  feedBackAnswer: null,
                })
              }
            >
              Peruuta ja sulje
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                changeReplyText(ReplyTextModalState.feedBackAnswer)
              }
            >
              Tallenna
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default FeedbackDetailsView;
